import { Box, Container, H2, Lead, Section, useBreakpoint } from 'react-components';
import { useAllPrismicDocumentsByType } from '@prismicio/react';
import { ConnectedTeamMember } from 'modules/landing/components/connected-team-member';
import React from 'react';
import { filterUndefined } from 'shared/utils/fn';

export const TeamMembers: React.FunctionComponent = () => {
  const isSmUp = useBreakpoint('sm');
  const [document] = useAllPrismicDocumentsByType('team');

  if (!document) {
    return null;
  }

  const [
    {
      data: { team_members },
    },
  ] = document;

  return (
    <Section bg={{ _: 'success.success50', sm: 'white' }}>
      <Container py={{ _: 4, sm: '6rem' }} $noPadding={!isSmUp} pb={0}>
        <Box display="flex" flexDirection={{ _: 'column', sm: 'row' }} px={{ _: '1.5rem', sm: 0 }}>
          <H2 flex="1" mt={0} mb={{ _: '1.5rem', sm: 0 }} fontSize={{ _: 8, sm: 10 }}>
            Team
          </H2>
          <Lead flex="1" color="black" my={0}>
            We are a diverse team of 6 people, fully dedicated to pier and its mission.{' '}
          </Lead>
        </Box>
        <Box
          mt={{ _: 4, sm: '6rem' }}
          display="grid"
          gridTemplateColumns={{ _: '1fr', sm: 'repeat(3, 1fr)' }}
          gridRowGap={{ _: 0, sm: 4 }}
          gridColumnGap={{ _: 0, sm: 3 }}
        >
          {team_members.filter(filterUndefined).map(({ team_member }: any) => (
            <ConnectedTeamMember key={team_member.id} id={team_member.id} />
          ))}
        </Box>
      </Container>
    </Section>
  );
};
